// export const MENUITEMS = [
// 	{
// 		Items: [
// 			{
// 				title: "Dashboard",
// 				key: "dashboard",
// 				icon: "dashboard",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/dashboard`
// 			},
// 			{
// 				title: "Manage Medicine",
// 				key: "add_medicine",
// 				icon: "medicine",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/medicines`
// 			},
// 			{
// 				title: "Purchase",
// 				key: "purchase",
// 				icon: "purchase",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/purchase`
// 			},
// 			{
// 				title: "Stocks",
// 				key: "manage_stock",
// 				icon: "stock",
// 				type: "sub",
// 				active: false,
// 				children: [
// 					{ path: `${process.env.PUBLIC_URL}/stock`, title: "Stocks", type: "link", key: "manage_stock" },
// 					{ path: `${process.env.PUBLIC_URL}/min-stock`, title: "Min Stock Alert", type: "link", key: "manage_stock" },
// 					{ path: `${process.env.PUBLIC_URL}/near-expire-stock`, title: "Near to Expire", type: "link", key: "manage_stock" },
// 					{ path: `${process.env.PUBLIC_URL}/expired-stock`, title: "Expired Stocks", type: "link", key: "manage_stock" },
// 				],
// 			},
// 			{
// 				title: "Sales",
// 				key: "new_sales",
// 				icon: "sales",
// 				type: "sub",
// 				active: false,
// 				children: [
// 					{ path: `${process.env.PUBLIC_URL}/new-sales`, title: "New Sales", type: "link", key: "new_sales" },
// 					{ path: `${process.env.PUBLIC_URL}/return-sales`, title: "Return Sales", type: "link", key: "new_sales" },
// 					{ path: `${process.env.PUBLIC_URL}/sales-history`, title: "Sales History", type: "link", key: "new_sales" },
// 				],
// 			},	
// 			{
// 				title: "Adjustments",
// 				key: "manage_inventory",
// 				icon: "inventory",
// 				type: "sub",
// 				active: false,
// 				children: [
// 					{ path: `${process.env.PUBLIC_URL}/add-inventory`, title: "Add Inventory", type: "link", key: "manage_inventory" },
// 					{ path: `${process.env.PUBLIC_URL}/adjust-inventory`, title: "Deduct Inventory", type: "link", key: "manage_inventory" },
// 					{ path: `${process.env.PUBLIC_URL}/inventory-history`, title: "Adjustment History", type: "link", key: "manage_inventory" },
// 				],
// 			},
// 			{
// 				title: "Ledger",
// 				key: "ledger",
// 				icon: "ledger",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/patient-ledger`
// 			},
// 			{
// 				title: "Transactions",
// 				key: "transaction",
// 				icon: "transaction",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/transactions`
// 			},
// 			{
// 				title: "Suppliers",
// 				key: "supplier",
// 				icon: "supplier",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/suppliers`
// 			},
// 			{
// 				title: "Settings",
// 				key: "tax",
// 				icon: "tax",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/manage-tax`
// 			},
// 			{
// 				title: "OTC",
// 				key: "OTC",
// 				icon: "OTC",
// 				type: "link",
// 				active: false,
// 				path: `${process.env.PUBLIC_URL}/OTC-products`
// 			},

// 			// { 
// 			// 	title: "Calendar", 
// 			// 	key: "calendar",
// 			// 	icon: "calendar", 
// 			// 	type: "link", 
// 			// 	active: false, 
// 			// 	path: `${process.env.PUBLIC_URL}/calendar/calendar-view`
// 			// },
// 			// { 
// 			// 	title: "Manage Admin Users", 
// 			// 	key: "manage_admin_users",
// 			// 	icon: "user", 
// 			// 	type: "link", 
// 			// 	active: false, 
// 			// 	path: `${process.env.PUBLIC_URL}/manage-admin-user/list`
// 			// },
// 			// { 
// 			// 	title: "Manage Patient",
// 			// 	key: "manage_patient",
// 			// 	icon: "user", 
// 			// 	type: "link", 
// 			// 	active: false, 
// 			// 	path: `${process.env.PUBLIC_URL}/manage-patient/list`
// 			// },
// 			// {
// 			// 	title: "Appointments",
// 			// 	key: "appointments",
// 			// 	icon: "calendar",
// 			// 	type: "sub",
// 			// 	active: false,
// 			// 	children: [
// 			// 		{ path: `${process.env.PUBLIC_URL}/appointments/upcoming-appointment`, title: "Upcoming", type: "link", key: "appointments", },
// 			// 		{ path: `${process.env.PUBLIC_URL}/appointments/completed-appointment`, title: "Past", type: "link", key: "completed_appointments", },
// 			// 	],
// 			// },
// 			// {
// 			// 	title: "Services",
// 			// 	key: "services",
// 			// 	icon: "services",
// 			// 	type: "sub",
// 			// 	active: false,
// 			// 	children: [
// 			// 		{ path: `${process.env.PUBLIC_URL}/services/pharmacy`, title: "Pharmacy", type: "link", key: "pharmacy", },
// 			// 		{
// 			// 			title: "Lab Test Service",
// 			// 			key: "laboratory",
// 			// 			type: "sub",
// 			// 			children: [
// 			// 				{ title: "Lab Tests", type: "link", path: `${process.env.PUBLIC_URL}/services/lab-tests`, key: "laboratory" },
// 			// 				{ title: "Lab Test Packages", type: "link", path: `${process.env.PUBLIC_URL}/services/lab-test-package`, key: "laboratory" },
// 			// 			],
// 			// 		},
// 			// 		{
// 			// 			title: "Imaging Service",
// 			// 			key: "imaging",
// 			// 			type: "sub",
// 			// 			children: [
// 			// 				{ title: "Imagings", type: "link", path: `${process.env.PUBLIC_URL}/services/imagings`, key: "imaging" },
// 			// 				{ title: "Imaging Packages", type: "link", path: `${process.env.PUBLIC_URL}/services/imaging-packages`, key: "imaging" },
// 			// 			],
// 			// 		},
// 			// 		{
// 			// 			title: "Special Test Service",
// 			// 			key: "special_test",
// 			// 			type: "sub",
// 			// 			children: [
// 			// 				{ title: "Special Tests", type: "link", path: `${process.env.PUBLIC_URL}/services/special-tests`, key: "special_test" },
// 			// 				{ title: "Special Test Packages", type: "link", path: `${process.env.PUBLIC_URL}/services/special-test-package`, key: "special_test" },
// 			// 			],
// 			// 		},
// 			// 		{
// 			// 			title: "Procedure Service",
// 			// 			key: "procedure",
// 			// 			type: "sub",
// 			// 			children: [
// 			// 				{ title: "Procedures", type: "link", path: `${process.env.PUBLIC_URL}/services/procedures`, key: "procedure" },
// 			// 				{ title: "Procedure Packages", type: "link", path: `${process.env.PUBLIC_URL}/services/procedure-packages`, key: "procedure" },
// 			// 			],
// 			// 		}
// 			// 	],
// 			// },
// 			// {
// 			// 	title: "Manage Privileges",
// 			// 	key: "manage_privileges",
// 			// 	icon: "widget",
// 			// 	type: "sub",
// 			// 	active: false,
// 			// 	children: [
// 			// 		{ path: `${process.env.PUBLIC_URL}/manage-privilege/clinic/list`, title: "Clinical Users Privilege", type: "link", key: "clinic_users_privilege", },
// 			// 		{ path: `${process.env.PUBLIC_URL}/manage-privilege/list`, title: "Admin Users Privilege", type: "link", key: "admin_users_privilege", },
// 			// 	],
// 			// },
// 			// {
// 			// 	title: "Manage Accounts",
// 			// 	key: "manage_accounts",
// 			// 	icon: "blog",
// 			// 	type: "sub",
// 			// 	active: false,
// 			// 	children: [
// 			// 		{ path: `${process.env.PUBLIC_URL}/manage-account/invoices-list`, title: "Invoices", type: "link", key: "all_invoices", },
// 			// 		{ path: `${process.env.PUBLIC_URL}/manage-account/raise-invoices-list`, title: "Raise Invoices", type: "link", key: "raise_invoices", },
// 			// 		{ path: `${process.env.PUBLIC_URL}/manage-account/bills-list`, title: "Bills", type: "link", key: "bill_list", },
// 			// 	],
// 			// },
// 			// {
// 			// 	title: "Chats",
// 			// 	key: "chats",
// 			// 	icon: "chat",
// 			// 	type: "link",
// 			// 	active: false,
// 			// 	path: `${process.env.PUBLIC_URL}/chats`
// 			// },
// 			// {
// 			// 	title: "News & Announcements",
// 			// 	key: "news_announcements",
// 			// 	icon: "knowledgebase",
// 			// 	type: "link",
// 			// 	active: false,
// 			// 	path: `${process.env.PUBLIC_URL}/news-announcement-list`
// 			// },
// 			// {
// 			// 	title: "Notifications",
// 			// 	key: "notification",
// 			// 	icon: "notification",
// 			// 	type: "link",
// 			// 	active: false,
// 			// 	path: `${process.env.PUBLIC_URL}/notifications`
// 			// },
// 			// {
// 			// 	title: "Settings",
// 			// 	key: "clinic_admin_settings",
// 			// 	icon: "settings",
// 			// 	type: "link",
// 			// 	active: false,
// 			// 	path: `${process.env.PUBLIC_URL}/clinic_admin_settings`
// 			// },
// 		],
// 	}
// ];

// ==============
// export const MENUITEMS = [
//   {
//     Items: [
//       {
//         title: "Dashboard",
//         key: "dashboard",
//         icon: "dashboard",
//         type: "link",
//         active: false,
//         path: `${process.env.PUBLIC_URL}/dashboard`
//       },
//       {
//         title: "POS",
//         key: "pos",
//         icon: "sales",
//         type: "link",
//         active: false,
//         path: `${process.env.PUBLIC_URL}/new-sales`
//       },
//       // {
//       //   title: "POS",
//       //   key: "pos",
//       //   icon: "pos",      // add a pos.svg / icon-pos class
//       //   type: "sub",
//       //   active: false,
//       //   path: `${process.env.PUBLIC_URL}/new-sales`,
//       //   children: [
//       //     { title: "New Sale", key: "new_sale", type: "link", path: `${process.env.PUBLIC_URL}/new-sales` },
//       //     { title: "Return Sale", key: "return_sale", type: "link", path: `${process.env.PUBLIC_URL}/return-sales` },
//       //     { title: "Sales History", key: "sales_history", type: "link", path: `${process.env.PUBLIC_URL}/sales-history` }
//       //   ]
//       // },
//       {
//         title: "Manage Items",
//         key: "items",
//         icon: "stock",
//         type: "link",
//         active: false,
//         path: `${process.env.PUBLIC_URL}/items`
//         // children: [
//         //   { title: "Medicine", key: "purchase", type: "link", path: `${process.env.PUBLIC_URL}/medicines` },
//         //   { title: "OTC", key: "supplier", type: "link", path: `${process.env.PUBLIC_URL}/OTC-products` }
//         // ]
//       },
//       {
//         title: "Purchase",
//         key: "purchase",
//         icon: "purchase",
//         type: "sub",
//         active: false,
//         children: [
//           { title: "Purchases", key: "purchases", type: "link", path: `${process.env.PUBLIC_URL}/purchase` },
//           { title: "Suppliers", key: "supplier", type: "link", path: `${process.env.PUBLIC_URL}/suppliers` },
//           // { title: "Transfer History", key: "transfer", type: "link", path: `${process.env.PUBLIC_URL}/transfer-history` }
//         ]
//       },
//       {
//         title: "Inventory",
//         key: "inventory",
//         icon: "inventory",
//         type: "sub",
//         active: false,
//         children: [
//           {
//             title: "Stocks",
//             key: "manage_stock",
//             type: "sub",
//             children: [
//               { path: `${process.env.PUBLIC_URL}/stock`, title: "Stocks", type: "link", key: "manage_stock" },
//               { path: `${process.env.PUBLIC_URL}/min-stock`, title: "Min Stock Alert", type: "link", key: "manage_stock" },
//               { path: `${process.env.PUBLIC_URL}/near-expire-stock`, title: "Near to Expire", type: "link", key: "manage_stock" },
//               { path: `${process.env.PUBLIC_URL}/expired-stock`, title: "Expired Stocks", type: "link", key: "manage_stock" },
//             ],
//           },
//           {
//             title: "Adjustments",
//             key: "manage_inventory",
//             type: "sub",
//             children: [
//               { path: `${process.env.PUBLIC_URL}/add-inventory`, title: "Add Inventory", type: "link", key: "manage_inventory" },
//               { path: `${process.env.PUBLIC_URL}/adjust-inventory`, title: "Deduct Inventory", type: "link", key: "manage_inventory" },
//               { path: `${process.env.PUBLIC_URL}/inventory-history`, title: "Adjustment History", type: "link", key: "manage_inventory" },
//             ],
//           }
//         ]
//       },
//       {
//         title: "Order List",
//         key: "order_list",
//         icon: "inventory",   // use tax.svg or gst.svg based on your icon set
//         type: "link",
//         active: false,
//         path: `${process.env.PUBLIC_URL}/pre-order-list`
//       },
//       {
//         title: "Sales & Finance",
//         key: "sales_finance",
//         icon: "sales",
//         type: "sub",
//         active: false,
//         children: [
//           { title: "Return Sale", key: "return_sale", type: "link", path: `${process.env.PUBLIC_URL}/return-sales` },
//           { title: "Sales History", key: "sales_history", type: "link", path: `${process.env.PUBLIC_URL}/sales-history` },
//           { title: "Patient Ledger", key: "ledger", type: "link", path: `${process.env.PUBLIC_URL}/patient-ledger` },
//         ]
//       },
//       // {
//       //   title: "GST Diary",
//       //   key: "gst_diary",
//       //   icon: "tax",   // use tax.svg or gst.svg based on your icon set
//       //   type: "link",
//       //   active: false,
//       //   path: `${process.env.PUBLIC_URL}/gst-diary`
//       // },
//       // {
//       //   title: "Sales & Finance",
//       //   key: "sales_finance",
//       //   icon: "sales",
//       //   type: "sub",
//       //   active: false,
//       //   children: [
//       //     {
//       //       title: "Sales",
//       //       key: "new_sales",
//       //       type: "sub",
//       //       children: [
//       //         { path: `${process.env.PUBLIC_URL}/new-sales`, title: "New Sales", type: "link", key: "new_sales" },
//       //         { path: `${process.env.PUBLIC_URL}/return-sales`, title: "Return Sales", type: "link", key: "new_sales" },
//       //         { path: `${process.env.PUBLIC_URL}/sales-history`, title: "Sales History", type: "link", key: "new_sales" },
//       //       ],
//       //     },
//       //     { title: "Patient Ledger", key: "ledger", type: "link", path: `${process.env.PUBLIC_URL}/patient-ledger` },
//       //     // { title: "Transactions", key: "transaction", type: "link", path: `${process.env.PUBLIC_URL}/transactions` }
//       //   ]
//       // },
//       {
//         title: "Staff & Shift",
//         key: "staff",
//         icon: "users",
//         type: "sub",
//         active: false,
//         children: [
//           { title: "Manage Staff", key: "manage_staff", type: "link", path: `${process.env.PUBLIC_URL}/manage-staff` },
//           { title: "Shift Record", key: "shift_record", type: "link", path: `${process.env.PUBLIC_URL}/shift-record` },
//         ]
//       },
//       // {
//       //   title: "Settings",
//       //   key: "settings",
//       //   icon: "settings",
//       //   type: "link",
//       //   active: false,
//       //   path: `${process.env.PUBLIC_URL}/manage-tax`
//       // },
//       {
//         title: "Transactions",
//         key: "transactions",
//         icon: "transactions",
//         type: "link",
//         active: false,
//         path: `${process.env.PUBLIC_URL}/transactions`
//       }
//     ]
//   }
// ];
// ==============

// ===================== FEATURE KEYS MAPPING =====================
// Maps menu item keys to plan feature keys
// This allows dynamic menu visibility based on plan features
// ===================== FEATURE KEYS MAPPING =====================
// Maps menu item keys to plan feature keys
export const MENU_FEATURE_MAPPING = {
  dashboard: null, // Always show
  pos_billing: null, // Always show
  items_purchases: null, // Always show
  suppliers: null, // Always show
  inventory: null, // Always show
  orders: "order_managment", // ✅ Matches planDetail.features[].key
  sales_ledger: null, // Always show
  staff: null, // ✅ /? Always show
  wallet_transactions: null, // Always show
  patient_accounts: null, // Always show
  pharma_doctors: null, // Always show
  shift_records: "reporting_level", // Matches planDetail.features[].key
};

export const MENUITEMS = [
  {
    Items: [
      /* ===================== DASHBOARD ===================== */
      {
        title: "Dashboard",
        key: "dashboard",
        icon: "dashboard",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/dashboard`,
        featureKey: null, // Always show
      },

      /* ===================== POS ===================== */
      {
        title: "POS",
        key: "pos_billing",
        icon: "sales",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/new-sales`,
        featureKey: null, // Always show
      },

      /* ===================== ITEMS ===================== */
      {
        title: "Items & Purchases",
        key: "items_purchases",
        icon: "stock",
        type: "sub",
        active: false,
        featureKey: null, // Always show
        children: [
          {
            title: "Manage Items",
            key: "manage_items",
            type: "link",
            path: `${process.env.PUBLIC_URL}/items`,
            featureKey: null, // Always show
          },
          {
            title: "New Purchase",
            key: "new_purchase",
            type: "link",
            path: `${process.env.PUBLIC_URL}/purchase`,
            featureKey: null, // Always show
          },
        ]
      },

      /* ===================== SUPPLIERS ===================== */
      {
        title: "Suppliers",
        key: "suppliers",
        icon: "supplier",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/suppliers`,
        featureKey: null, // Always show
      },

      /* ===================== INVENTORY ===================== */
      {
        title: "Inventory",
        key: "inventory",
        icon: "inventory",
        type: "sub",
        active: false,
        featureKey: null, // Always show
        children: [
          {
            title: "Stock List",
            key: "stock_list",
            type: "link",
            path: `${process.env.PUBLIC_URL}/stock`,
            featureKey: null, // Always show
          },
          {
            title: "Min Stock Alerts",
            key: "min_stock",
            type: "link",
            path: `${process.env.PUBLIC_URL}/min-stock`,
            featureKey: null, // Always show
          },
          {
            title: "Near Expiry",
            key: "near_expiry",
            type: "link",
            path: `${process.env.PUBLIC_URL}/near-expire-stock`,
            featureKey: null, // Always show
          },
          {
            title: "Expired Stock",
            key: "expired_stock",
            type: "link",
            path: `${process.env.PUBLIC_URL}/expired-stock`,
            featureKey: null, // Always show
          },
          {
            title: "Add Inventory",
            key: "add_inventory",
            type: "link",
            path: `${process.env.PUBLIC_URL}/add-inventory`,
            featureKey: null, // Always show
          },
          {
            title: "Deduct Inventory",
            key: "adjust_inventory",
            type: "link",
            path: `${process.env.PUBLIC_URL}/adjust-inventory`,
            featureKey: null, // Always show
          },
          {
            title: "Adjustment History",
            key: "adjustment_history",
            type: "link",
            path: `${process.env.PUBLIC_URL}/inventory-history`,
            featureKey: null, // Always show
          },
        ],
      },

      /* ===================== ORDERS ===================== */
      {
        title: "Orders",
        key: "orders",
        icon: "orders",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/pre-order-list`,
        featureKey: "order_managment", // ✅ Matches your license data
      },

      /* ===================== SALES & LEDGER ===================== */
      {
        title: "Sales & Ledger",
        key: "sales_ledger",
        icon: "ledger",
        type: "sub",
        active: false,
        featureKey: null, // Always show
        children: [
          {
            title: "Sales History",
            key: "sales_history",
            type: "link",
            active: false,
            path: `${process.env.PUBLIC_URL}/sales-history`,
            featureKey: null, // Always show
          },
          {
            title: "Product Sales History",
            key: "product_sales_history",
            type: "link",
            active: false,
            path: `${process.env.PUBLIC_URL}/product-sales-history`,
            featureKey: null, // Always show
          },
          {
            title: "Sale Returns",
            key: "sale_returns",
            type: "link",
            active: false,
            path: `${process.env.PUBLIC_URL}/return-sales`,
            featureKey: null, // Always show
          },
          {
            title: "Patient Ledger",
            key: "patient_ledger",
            type: "link",
            active: false,
            path: `${process.env.PUBLIC_URL}/patient-ledger`,
            featureKey: null, // Always show
          },
        ],
      },

      /* ===================== PATIENT ACCOUNTS ===================== */
      {
        title: "Patient Accounts",
        key: "patient_accounts",
        icon: "patient_accounts",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/patient-accounts`,
        featureKey: null, // Shown when pharmacy_collects_payment + isHospitalConnected
      },

      /* ===================== PHARMA DOCTORS ===================== */
      {
        title: "Doctors",
        key: "pharma_doctors",
        icon: "pharma_doctors",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/pharma-doctors`,
        featureKey: null, // Always show
      },

      /* ===================== STAFF & SHIFTS ===================== */
      {
        title: "Staff & Shifts",
        key: "staff",
        icon: "users",
        type: "sub",
        active: false,
        featureKey: null, // ✅ Matches your license data
        children: [
          {
            title: "Staff Management",
            key: "shifts",
            type: "link",
            active: false,
            path: `${process.env.PUBLIC_URL}/manage-staff`,
            featureKey: null,
          },
          {
            title: "Shift Records",
            key: "shift_records",
            type: "link",
            active: false,
            path: `${process.env.PUBLIC_URL}/shift-record`,
            featureKey: "reporting_level",
          },
        ],
      },

      /* ===================== WALLET & TRANSACTIONS ===================== */
      {
        title: "Wallet & Transactions",
        key: "wallet_transactions",
        icon: "transactions",
        type: "link",
        active: false,
        path: `${process.env.PUBLIC_URL}/transactions`,
        featureKey: null, // Always show
      },
    ],
  },
];
